export const nonNullable = <T>(value: T): value is NonNullable<T> =>
  value != null || value !== undefined;

export function isAllEqual<T>(array: T[]): boolean {
  if (array.length === 0) return false;
  return array.every((value) => value === array[0]);
}
